import React, { useEffect, useState } from "react";
import { Modal3 } from "../../../../../components/DIsplay/Modal/Modal3";
import Button1 from "../../../../../components/form/Button1";
import CommonFreeTextInput from "../../../../../components/common/inputs/CommonFreeTextInput";
import { enqueueSnackbar } from "notistack";
import CommonDatePicker from "../../../../../components/common/inputs/CommonDatePicker";
import CommonInputContainer from "../../../../../components/common/inputs/CommonInputContainer";
import CommonCountryInput from "../../../../../components/common/inputs/CommonCountryInput";
import moment from "moment";

function EditPassengerDocumentDetail({
  open,
  setOpen,
  data: { onUpdateTicket, updatedTicket, flightBooking, bookingData, order },
}) {
  const [detail, setDetail] = useState({
    dateOfBirth: "",
    passportNo: "",
    expiryDate: "",
    nationality: "",
  });

  const updateDetailOnOpen = () => {
    if (typeof open !== "string") return;
    const index = Number(open);
    const data = updatedTicket || flightBooking;
    const passenger = data?.travelers?.at(index);
    if (passenger) {
      setDetail({
        dateOfBirth: passenger?.birthDate || "",
        passportNo: passenger?.document?.number || "",
        expiryDate: passenger?.document?.expiryDate || "",
        nationality: passenger?.document?.nationality || "",
      });
    }
  };

  useEffect(() => {
    updateDetailOnOpen();
  }, [open]);

  const isEmpty = (v) =>
    v === null || v === undefined || (typeof v === "string" && v.trim() === "");

  const REQUIRED_FIELDS = [
    { key: "dateOfBirth", label: "Date of birth" },
    { key: "passportNo", label: "Passport number" },
    { key: "expiryDate", label: "Expiry date" },
    { key: "nationality", label: "Nationality" },
  ];

  const firstMissingLabel = (detail) => {
    for (const f of REQUIRED_FIELDS) {
      if (isEmpty(detail[f.key])) return f.label;
    }
    return null;
  };

  const handleSave = () => {
    const missing = firstMissingLabel(detail);
    if (missing) {
      enqueueSnackbar(`${missing} is required.`, { variant: "warning" });
      return;
    }
    if (typeof open !== "string") return;
    const index = Number(open);
    const data = updatedTicket || flightBooking;
    onUpdateTicket({
      ...data,
      travelers:
        data?.travelers?.map((traveler, travelerIndex) =>
          travelerIndex === index
            ? {
                ...traveler,
                birthDate: detail.dateOfBirth,
                document: {
                  ...(traveler?.document || {}),
                  expiryDate: detail?.expiryDate,
                  nationality: detail?.nationality,
                  issuanceCountry: detail?.nationality,
                  birthPlace: detail?.nationality,
                  issuanceLocation: detail?.nationality,
                  validityCountry: detail?.nationality,
                  number: detail?.passportNo,
                },
              }
            : traveler,
        ) || [],
    });
    // const finalId = normalize(orderId);
    // updatedTicket
    //   ? onUpdateTicket({ ...updatedTicket, bookingId: finalId })
    //   : onUpdateTicket({ ...flightBooking, bookingId: finalId });
    setOpen(false);
  };

  // console.log({ detail });

  return (
    <div>
      <Modal3 open={open} setOpen={setOpen} title="Edit Passenger Document">
        <div className="card p-6 flex flex-col gap-5 justify-start w-96 min-h-[60vh]">
          <div>
            <CommonInputContainer label="Date of Birth">
              <CommonDatePicker
                maxDate={new Date()}
                value={detail.dateOfBirth}
                onChange={(date) =>
                  setDetail({
                    ...detail,
                    dateOfBirth: moment(date).format("YYYY-MM-DD"),
                  })
                }
              />
            </CommonInputContainer>
          </div>
          <div>
            <CommonInputContainer label="Passport Expiry Date">
              <CommonDatePicker
                minDate={new Date()}
                value={detail.expiryDate}
                onChange={(date) =>
                  setDetail({
                    ...detail,
                    expiryDate: moment(date).format("YYYY-MM-DD"),
                  })
                }
                calenderPosition="-top-10"
              />
            </CommonInputContainer>
          </div>
          <div>
            <CommonFreeTextInput
              value={detail?.passportNo}
              onChange={(val) => setDetail({ ...detail, passportNo: val })}
              label="Passport Number"
              placeholder="e.g. A1234567"
            />
          </div>
          <div>
            <CommonCountryInput
              value={detail?.nationality}
              onChange={(val) => setDetail({ ...detail, nationality: val })}
              label="Nationality"
              placeholder="e.g. Nigeria"
              dropdownPosition="bottom-20"
            />
          </div>
          {/* <CommonDate */}

          <div className="flex gap-3 items-center justify-end">
            <Button1
              variant="outlined"
              className="whitespace-nowrap"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button1>
            <Button1 onClick={handleSave}>Save Draft</Button1>
          </div>
        </div>
      </Modal3>
    </div>
  );
}

export default EditPassengerDocumentDetail;
